class Accordion {
  constructor(element) {
    this.detail = element.querySelector('details');
    this.summary = element.querySelector('summary');
    this.content = element.querySelector('.accordion__content');
    this.innerEl = element.querySelector('.accordion__content-inner');
    this.button = element.querySelector('.accordion__close');
    this.trackCategory = this.detail.dataset.eventcategory;
    this.trackName = this.detail.dataset.eventname !== '' ? this.detail.dataset.eventname : 'accordion';
    this.animationDuration = getComputedStyle(document.documentElement).getPropertyValue('--accordion-duration');

    element.classList.add('accordion--initialized');

    this.summary.addEventListener('click', async (event) => {
      event.preventDefault();
      window.clearTimeout(this.animationRemovalTimeout);
      const isCollapsed = this.detail.classList.contains('accordion__details--collapsed');
      isCollapsed ? this.expand(event) : this.collapse(event);
    });

    if (this.button) {
      this.button.addEventListener('click', () => this.collapse());
    }
  }

  expand() {
    this.detail.open = true;
    this.content.style.maxHeight = `${this.innerEl.offsetHeight}px`;
    this.detail.classList.remove('accordion__details--collapsed');
  }

  collapse() {
    this.detail.classList.add('accordion__details--collapsed');
    this.animationRemovalTimeout = window.setTimeout(() => {
      this.detail.open = false;
    }, parseFloat(this.animationDuration) * 1000);
  }
}

const scrollToAndOpen = () => {
  const id = window.location.hash.split('#')[1];
  if (document.getElementById(id)) {
    const item = document.getElementById(id);
    const accordion = item.querySelector(':scope > details > summary');
    if (accordion) {
      accordion.click();
    }
  }
};

function init() {
  [...document.querySelectorAll('.js-accordion')].forEach((accordion) => {
    new Accordion(accordion);
  });

  if (document.querySelector('.js-accordion')) {
    window.addEventListener('hashchange', scrollToAndOpen);

    if (window.location.hash) {
      scrollToAndOpen();
    }
  }
}

export { init };
